export const CRMContacts = [
  {
    "First Name": "John",
    "Last Name": "Doe",
    Email: "john.doe@example.com",
    Company: "Acme Corp",
    Phone: "9123456789",
    Position: "Sales Manager",
    "Last Login": "2025-04-01 08:30:00",
    Active: "Yes",
  },
  {
    "First Name": "Jane",
    "Last Name": "Smith",
    Email: "jane.smith@example.com",
    Company: "BetaTech Ltd.",
    Phone: "9876543210",
    Position: "Developer",
    "Last Login": "2025-03-30 14:45:00",
    Active: "Yes",
  },
  {
    "First Name": "Michael",
    "Last Name": "Brown",
    Email: "michael.brown@example.com",
    Company: "Creative Solutions",
    Phone: "9988776655",
    Position: "Marketing Director",
    "Last Login": "2025-03-25 09:20:00",
    Active: "No",
  },
  {
    "First Name": "Sarah",
    "Last Name": "White",
    Email: "sarah.white@example.com",
    Company: "TechWave",
    Phone: "7778889999",
    Position: "HR Specialist",
    "Last Login": "2025-04-01 12:00:00",
    Active: "Yes",
  },
  {
    "First Name": "David",
    "Last Name": "Clark",
    Email: "david.clark@example.com",
    Company: "Digital Ventures",
    Phone: "8211122333",
    Position: "CEO",
    "Last Login": "2025-03-28 16:30:00",
    Active: "Yes",
  },
  {
    "First Name": "Emily",
    "Last Name": "Johnson",
    Email: "emily.johnson@example.com",
    Company: "GreenTech",
    Phone: "7733445566",
    Position: "Operations Lead",
    "Last Login": "2025-03-29 10:10:00",
    Active: "No",
  },
  {
    "First Name": "Robert",
    "Last Name": "Miller",
    Email: "robert.miller@example.com",
    Company: "Innovate Global",
    Phone: "9811223344",
    Position: "CTO",
    "Last Login": "2025-04-01 08:45:00",
    Active: "Yes",
  },
  {
    "First Name": "Olivia",
    "Last Name": "Davis",
    Email: "olivia.davis@example.com",
    Company: "WebXplore",
    Phone: "9201112233",
    Position: "UX/UI Designer",
    "Last Login": "2025-03-30 11:00:00",
    Active: "Yes",
  },
  {
    "First Name": "James",
    "Last Name": "Wilson",
    Email: "james.wilson@example.com",
    Company: "NextGen Tech",
    Phone: "8887776666",
    Position: "Product Manager",
    "Last Login": "2025-03-25 15:15:00",
    Active: "No",
  },
  {
    "First Name": "Lisa",
    "Last Name": "Taylor",
    Email: "lisa.taylor@example.com",
    Company: "SkyNet Industries",
    Phone: "9445566777",
    Position: "Project Manager",
    "Last Login": "2025-03-27 13:00:00",
    Active: "Yes",
  },
  {
    "First Name": "Tom",
    "Last Name": "Harris",
    Email: "tom.harris@example.com",
    Company: "FutureTech",
    Phone: "9876654321",
    Position: "Software Engineer",
    "Last Login": "2025-04-01 10:00:00",
    Active: "Yes",
  },
  {
    "First Name": "Sophia",
    "Last Name": "Gonzalez",
    Email: "sophia.gonzalez@example.com",
    Company: "MetaDesign",
    Phone: "9212345678",
    Position: "Designer",
    "Last Login": "2025-03-29 08:00:00",
    Active: "Yes",
  },
];
